export const ROOT_NODE_SELECTOR = '#creator-nav-root';

// modal types

export enum ModalType {
    simple = 'simple',
    aperture = 'aperture',
    takeover = 'takeover',
    complex = 'complex',
}

export const TYPES = [ModalType.simple, ModalType.aperture, ModalType.takeover, ModalType.complex];

/**
 * Interaction modes for pane layout component
 */
export enum PaneLayoutInteractionType {
    asCollapsible = 'as-collapsible',
    asModal = 'as-modal',
}

export const PANE_LAYOUT_INTERACTION_TYPES = [
    PaneLayoutInteractionType.asCollapsible,
    PaneLayoutInteractionType.asModal,
];

/**
 * @deprecated Use `ModalType.simple` instead
 */
export const TYPE_SIMPLE = ModalType.simple;
/**
 * @deprecated Use `ModalType.aperture` instead
 */
export const TYPE_APERTURE = ModalType.aperture;
/**
 * @deprecated Use `ModalType.takeover` instead
 */
export const TYPE_TAKEOVER = ModalType.takeover;
/**
 * @deprecated Use `ModalType.complex` instead
 */
export const TYPE_COMPLEX = ModalType.complex;

export const MODAL_TITLE_ID = 'eds-modal-title';
